<template lang='pug'>
.breadcrumb.show--smallScreens(v-if="!isPartner" :class='normal ? "breadcrumb--normal" : ""')
  router-link.breadcrumb-text(v-for='(breadcrumb, idx) in breadcrumbList' :to='breadcrumb.link' :key='idx') {{ breadcrumb.text }}
</template>
<script>
export default {
  props: {
    breadcrumbList: Array,
    normal: Boolean
  },
  computed: {
    isPartner() {
      const identity = localStorage.getItem(this.$store.state.storageKeys.identity)
      return identity === 'government' || identity === 'partners'
    }
  }
}
</script>
